import api from './api';


export const getGoogleCalendarConnections = () =>
  api.get('/google-calendar/connections');

export const startGoogleCalendarOAuth = (professionalId) =>
  api.post('/google-calendar/oauth/start', { professional_id: professionalId });

export const syncGoogleCalendar = (professionalId) =>
  api.post(`/google-calendar/connections/${professionalId}/sync`);

export const retryGoogleCalendar = (professionalId) =>
  api.post(`/google-calendar/connections/${professionalId}/retry`);

export const disconnectGoogleCalendar = (professionalId, removeEvents = false) =>
  api.delete(`/google-calendar/connections/${professionalId}`, {
    data: { remove_events: removeEvents },
  });
